"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENCY_SYMBOL = void 0;
var CURRENCY_SYMBOL = {
  AUS: 'AUD $',
  US: 'USD $',
  ASIA_US: 'USD $',
  SG: 'SGD $',
  UK: '£',
  EU: 'EUR €',
  HK: 'HKD $'
};
exports.CURRENCY_SYMBOL = CURRENCY_SYMBOL;